// ADR-0154 — las dos entradas del análisis de cartera con IA: `/analisis`
// (la cartera completa) y `/proyectos/:id/analisis` (ese proyecto contra
// el resto). Una URL directa de un rol o una vertical sin análisis vuelve
// al inicio, como las demás guardias del shell.

import { Link, Navigate, useParams } from "react-router-dom";
import { AnalisisCartera } from "../components/AnalisisCartera";
import { useSession } from "../lib/auth/useSession";
import { useCarteraProyectoDetail, useRecipe } from "../lib/api/queries";
import { canUsePortfolioAnalysis } from "../lib/nav";

export function AnalisisRoute() {
  const { id } = useParams<{ id: string }>();
  const { data: recipe } = useRecipe();
  const role = useSession()?.organization.role;
  // Mismo `{ limit: 1 }` que el rail del proyecto: comparten la entrada
  // de caché y el nombre llega sin otra llamada.
  const detail = useCarteraProyectoDetail(id, { limit: 1 });

  if (recipe === undefined) return null;
  if (!canUsePortfolioAnalysis(role, recipe)) return <Navigate to="/" replace />;

  const groupPlural = recipe.labels.assetGroupPlural;
  if (!id) {
    return (
      <AnalisisCartera
        eyebrow={<Link to="/proyectos">{groupPlural}</Link>}
        title="Análisis de cartera"
      />
    );
  }

  const nombre = detail.data?.group.name;
  return (
    <AnalisisCartera
      key={id}
      assetGroupId={id}
      eyebrow={
        <>
          <Link to="/proyectos">{groupPlural}</Link> /{" "}
          <Link to={`/proyectos/${id}`}>{nombre ?? recipe.labels.assetGroup}</Link>
        </>
      }
      title={nombre ? `Análisis de ${nombre}` : "Análisis del proyecto"}
    />
  );
}
